import script from "./UserOrderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOrderComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserOrderComponent.vue?vue&type=style&index=0&id=2ec93e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec93e2a"]])

export default __exports__